import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "fv-row mb-7" }
const _hoisted_3 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["disabled", "onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = ["srcdoc"]

import { ref, reactive, computed, onMounted } from "vue";
import SiderDetail from "@/components/SiderDetail.vue";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import GlobalService from "../../../services/TenantGlobalService";
import type { FormInstance, FormRules } from "element-plus";
import SendTestEmail from "../components/SendTestEmail.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailDetail',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const emailDetailShowRef = ref<InstanceType<typeof SiderDetail>>();
const sendTestEmailRef = ref<InstanceType<typeof SendTestEmail>>();
const templateHtmlShowRef = ref(null);

const isLoading = ref(true);
const submited = ref(false);

const detail = ref(Array<any>());
const detailTitle = ref("");

const layoutTemplate = ref({});

const emailLangFormRef = ref<FormInstance>();

const languageOptions = ref([]);

const langDetail = ref({
  title: "",
  subtitle: "",
  content: "",
  language: "",
  id: 0,
});

const isAllLanguage = ref(false);

const langFormRules = reactive<FormRules>({
  title: [{ required: true, message: "Please input title" }],
  subtitle: [{ required: true, message: "Please input subtitle" }],
  content: [{ required: true, message: "Please input content" }],
  language: [{ required: true, message: "Please select language" }],
});

const layoutTemplateHtml = ref("");

const refreshLayoutTemplateHtml = () => {
  if (templateHtmlShowRef.value == null) {
    return;
  }
  if (langDetail.value.language == "") {
    layoutTemplateHtml.value = "";
    templateHtmlShowRef.value.srcdoc = "";
    return;
  }
  if (detail.value.id == layoutTemplate.value.id) {
    layoutTemplateHtml.value =
      layoutTemplate.value.contents[langDetail.value.language].content;
    templateHtmlShowRef.value.srcdoc = layoutTemplateHtml.value;
    return;
  }
  var t = layoutTemplate.value.contents[langDetail.value.language].content;
  t = t.replace("{{Title}}", langDetail.value.title);
  t = t.replace("{{Subtitle}}", langDetail.value.subtitle);
  t = t.replace("{{Content}}", langDetail.value.content);
  layoutTemplateHtml.value = t;
  templateHtmlShowRef.value.srcdoc = t;
  return;
};

const tab = ref("new");

const show = (data, layout) => {
  layoutTemplate.value = layout;
  detail.value = data;
  detailTitle.value = detail.value.title + " Email Detail";

  let keys = Object.keys(detail.value.contents);
  if (keys.length > 0) {
    changeTab(keys[0], detail.value.contents[keys[0]]);
  } else {
    changeTab("new", null);
  }

  isAllLanguage.value = keys.length >= LanguageTypes.all.length;
  isLoading.value = false;
  emailDetailShowRef.value?.show();
  refreshLayoutTemplateHtml();
};

const sendTest = (title, lang) => {
  sendTestEmailRef.value.show(title, lang);
};

const changeTab = (_tab, item) => {
  tab.value = _tab;
  if (item) {
    langDetail.value = {
      title: item.title,
      subtitle: item.subtitle,
      content: item.content,
      language: item.language,
      id: item.id,
    };
    languageOptions.value = LanguageTypes.all.filter(
      (langItem) => langItem.code == item.language
    );
  } else {
    langDetail.value = {
      title: "",
      subtitle: "",
      content: "",
      language: "",
      id: 0,
    };
    languageOptions.value = LanguageTypes.all.filter(
      (langItem) => detail.value.contents[langItem.code] == undefined
    );
  }
  refreshLayoutTemplateHtml();
};



const submit = async () => {
  submited.value = true;
  console.log(langDetail.value);
  if (langDetail.value.id == 0) {
    await createEmailLanguage();
  } else {
    await updateEmailLanguage();
  }
  emits("eventSubmit");
  refreshLayoutTemplateHtml();
  submited.value = false;
};

const updateEmailLanguage = async () => {
  console.log(langDetail.value.id);
  GlobalService.updateEmailLanguage(
    detail.value.id,
    langDetail.value.id,
    langDetail.value
  );
  console.log("update email language");
};

const createEmailLanguage = async () => {
  GlobalService.createEmailLanguage(detail.value.id, langDetail.value);
  console.log("save email language");
};
const close = () => {
  emailDetailShowRef.value?.hide();
  emits("eventSubmit");
};
onMounted(() => {
  //
});

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SiderDetail, {
      save: submit,
      discard: close,
      title: detailTitle.value,
      elId: "user_detail_show",
      isLoading: isLoading.value,
      submited: submited.value,
      isDisabled: false,
      savingTitle: _ctx.$t('action.saving'),
      "show-footer": false,
      width: "{default:'90%'}",
      ref_key: "emailDetailShowRef",
      ref: emailDetailShowRef
    }, {
      default: _withCtx(() => [
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("ul", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.contents, (item, key, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "nav-item",
                      key: index
                    }, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === key }]),
                        "data-bs-toggle": "tab",
                        onClick: ($event: any) => (changeTab(key, item))
                      }, _toDisplayString(key), 11, _hoisted_4)
                    ]))
                  }), 128)),
                  (!isAllLanguage.value)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === 'new' }]),
                          "data-bs-toggle": "tab",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab('new', null)))
                        }, _toDisplayString(_ctx.$t("action.new")), 3)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_form, {
                    ref_key: "emailLangFormRef",
                    ref: emailLangFormRef,
                    model: langDetail.value,
                    rules: langFormRules,
                    "label-width": "120px",
                    class: "demo-ruleForm",
                    size: "default",
                    "status-icon": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.language'),
                        prop: "role"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: langDetail.value.language,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((langDetail.value.language) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageOptions.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.code,
                                  label: item.name,
                                  value: item.code
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.title'),
                        prop: "title"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: langDetail.value.title,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((langDetail.value.title) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.subtitle'),
                        prop: "subtitle"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: langDetail.value.subtitle,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((langDetail.value.subtitle) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.content'),
                        prop: "title"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: langDetail.value.content,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((langDetail.value.content) = $event)),
                            type: "textarea",
                            onChange: refreshLayoutTemplateHtml,
                            autosize: { minRows: 20 }
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          class: "btn btn-warning me-3",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (sendTest(detail.value.title, langDetail.value.language)), ["prevent"]))
                        }, " Test "),
                        _createElementVNode("button", {
                          class: _normalizeClass(`btn btn-secondary me-3`),
                          onClick: _withModifiers(close, ["prevent"])
                        }, _toDisplayString(_ctx.$t("action.close")), 9, _hoisted_9),
                        _createElementVNode("button", {
                          class: _normalizeClass(`btn btn-primary me-3`),
                          type: "submit",
                          disabled: submited.value || isLoading.value,
                          onClick: _withModifiers(submit, ["prevent"])
                        }, [
                          (submited.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.waiting")) + " ", 1),
                                _hoisted_12
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("action.submit")), 1))
                        ], 8, _hoisted_10)
                      ])
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("iframe", {
                    style: {"width":"600px","height":"100%"},
                    ref_key: "templateHtmlShowRef",
                    ref: templateHtmlShowRef,
                    srcdoc: layoutTemplateHtml.value
                  }, "\n          ", 8, _hoisted_15)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "isLoading", "submited", "savingTitle"]),
    _createVNode(SendTestEmail, {
      ref_key: "sendTestEmailRef",
      ref: sendTestEmailRef
    }, null, 512)
  ], 64))
}
}

})